import type { Repasse } from "./schema"

// A data de hoje no fuso de quem paga a guia, e não no do navegador: um RH viajando ou uma máquina
// em UTC não pode ver a guia vencer três horas antes.
const hojeEmSaoPaulo = (agora: Date) =>
    new Intl.DateTimeFormat("en-CA", { timeZone: "America/Sao_Paulo" }).format(agora)

// O serviço manda o vencimento como dd/MM, e a guia vence dentro do mês da referência — o ano
// sai da referência. No próprio dia do vencimento ela ainda está a vencer: pagar hoje é em dia.
export const rotuloDaGuia = (
    { competencia, referencia, vencimentoGuia }: Repasse,
    agora = new Date(),
) => {
    const [dia, mes] = vencimentoGuia.split("/")
    const vencimento = `${referencia.slice(0, 4)}-${mes}-${dia}`
    const situacao = hojeEmSaoPaulo(agora) > vencimento ? "venceu" : "a vencer"
    return `Guia da folha de ${competencia} · ${situacao} ${vencimentoGuia}`
}
